import * as actionTypes from 'src/actions';

const initialState = {
  currentCompany: null,
  companyError: false,
  integrationSettings: {},
  nextIntegration: null
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY_SUCCESS: {
      return {
        ...state,
        currentCompany: action.company
      };
    }

    case actionTypes.FETCH_COMPANY_IS_SUCCESS: {
      return {
        ...state,
        integrationSettings: {
          ...action.data
        }
      };
    }

    case actionTypes.FETCH_COMPANY_ERROR: {
      state.error = action.error;
      return {
        ...state,
        companyError: action.error
      };
    }

    case actionTypes.SET_NEXT_INTEGRATION: {
      return {
        ...state,
        nextIntegration: action.data
      };
    }

    default: {
      return state;
    }
  }
};

export default companyReducer;
